export const STATUS_COMMISION = {
  pending: {
    label: 'Pending',
    color: 'warning',
  },
  completed: {
    label: 'Selesai',
    color: 'green',
  },
  rejected: {
    label: 'Ditolak',
    color: 'danger',
  },
  cancelled: {
    label: 'Dibatalkan',
    color: 'danger',
  },
};

export type CommisionType = keyof typeof STATUS_COMMISION;
